import { Types } from "./action";

const defaultState = {
  coupon: {},
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case Types.COUPON_GET_ITEM: {
      let newState = { ...state };
      newState.coupon.item = action.payload?.getCoupon;
      return newState;
    }
    case Types.COUPON_GET_LIST: {
      let newState = { ...state };
      if (!newState.coupon.list) newState.coupon.list = [];
      newState.coupon.list = [
        ...newState.coupon.list,
        ...action.payload?.listCoupons?.items,
      ];

      newState.coupon.listNextToken = action.payload?.listCoupons?.nextToken;
      newState.coupon.listStartedAt = action.payload?.listCoupons?.startedAt;

      return newState;
    }
    case Types.COUPON_CREATE_ITEM: {
      let newState = { ...state };
      newState.coupon.item = action.payload;
      return newState;
    }
    case Types.COUPON_UPDATE_ITEM: {
      let newState = { ...state };

      const updatedItem = action.payload;
      newState.coupon.item = action.payload;

      if (newState.coupon.list) {
        const itemIndex = newState.coupon.list.findIndex(
          (item) => item.id == updatedItem.id
        );
        newState.coupon.list[itemIndex] = updatedItem;
      }

      return newState;
    }
    case Types.COUPON_CLEAR_ITEM: {
      let newState = { ...state };
      newState.coupon.item = null;
      return newState;
    }
    case Types.COUPON_DELETE_ITEM: {
      let newState = { ...state };
      newState.coupon.item = { ...newState.coupon.item, _deleted: true };
      return newState;
    }
    default:
      return state;
  }
};

export default reducer;
